import React from 'react';
import LazyImg from '../lazy_img';

export default ({ photoUrl, name }) => (
    <div className="c-profile__image-container">
        <LazyImg
            className="c-profile__image"
            src={photoUrl}
            alt={name || ""}
        />
    </div>
);


// WEBPACK FOOTER //
// ./components/profile/profile_photo.jsx